export default __webpack_public_path__ + "static/NotoSans-Bold-66ab29744a551a59e9f54e249e8f6434.ttf";